<template>
  <div id="app">
    <a-config-provider :locale="zhCN">
      <a-spin v-bind="loadingProps">
        <router-view />
      </a-spin>
    </a-config-provider>
  </div>
</template>

<script>
import Vue from 'vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
export default {
  name: 'App',
  data () {
    return {
      zhCN,
      loadingProps: {
        spinning: false
      }
    }
  },
  methods: {},
  created () {
    if (localStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem('store'))))
    }
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('store', JSON.stringify(this.$store.state))
    })
    window.addEventListener('resize', () => {})
  },
  beforeCreate () {
    Vue.prototype.$app = this
  }
}

</script>

<style lang="less">
#app {
  height: 100vh;
  background: #F3F4F7;
}

</style>



// WEBPACK FOOTER //
// src/App.vue